import { container } from '../services/container'

export const sections = {
  methods: {
    isSectionPageActive(sectionPage) {
      let enabledUrl = sectionPage.enabledUrls.find(i => {
        return this.$route.path.includes(i)
      })

      return enabledUrl || (this.sectionPageActive && this.sectionPageActive.name == sectionPage.name)
    },
  },
	computed: {
    currentSectionPage() {
      return this.sectionPages.find(i => {
        return this.isSectionPageActive(i)
      })
    },

    getNextSectionPage() {
      if (!this.currentSectionPage) {
        return null;
      }

      return this.sectionPages.find(sectionPage => {
        return sectionPage.position > this.currentSectionPage.position
      })
    },

		sectionPages () {
      let config = JSON.parse(window.config["quomi.checkout.new-top-sections"])

      let source = container.get('source').getValue();

      if (!source || source == 'order-now') {
        source = 'default';
      }

      return config.filter(i => {
          return i.source && i.source.indexOf(source) !== -1
      })
    },
    sectionPageActive() {
      return this.sectionPages.find(el => {
        return el.items.find(i => { 
          return i.url == this.$route.params.tag;
        })
      })
    },
    sections () {
      // @todo, in case of multiple shops with multiple or different steps based on source convert this and routing
      let page = this.sectionPageActive
      let sections = [];

      if (page) {
        sections = page.items;
      } else {
        return [];
      }

      let source = container.get('source').getValue();

      if (source == 'order-now') {
        source = 'default';
      }

      if (source) {
          sections = sections.filter(i => {
              return i.source && i.source.indexOf(source) !== -1
          })
      } else {
          sections = sections.filter(i => {
              return !i.source || i.source.indexOf("default") !== -1
          })
      }

      return sections
    },
    section () {
        let tag = this.$route.params.tag;
        return this.sections.find(i => {
            return i.url == tag
        })
    },
	},
}
